import React from 'react';

function Hero() {
    const callToAction = "Notify Me";

    return (
        <section id="hero">
            <h2>Auglabs is under development!</h2>
            <p>Our aim is to democratise the most advanced technology for all. We do this through product and service development, information and crisis planning/services, and consultancy services.</p>
            <button>{callToAction}</button>
        </section>
    );
}

export default Hero;